import React from "react";
import { Controller as Fc } from "react-hook-form";
import { Box } from "@mui/material";
import { ButtonBase } from "@mui/material";
import { Typography } from "@mui/material";

const QuestionNPS = ({
  setValue,
  control,
  item,
  customStyle,
  npsAnswers,
  setNpsAnswers,
}) => {
  const npsScale = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  // If no control provided, use native form input with state
  if (!control) {
    const selectedValue = npsAnswers?.[item.id] ?? null;

    return (
      <>
        <Box
          mt={1}
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: "0px",
            justifyContent: "space-between",
            width: "100%",
            borderRadius: "10px",
            border: `1px solid ${customStyle?.borderColor ?? "#D9DBE9"}`,
            overflow: "hidden",
          }}
        >
          {npsScale.map((value, index) => {
            const isSelected = selectedValue === value;
            return (
              <ButtonBase
                key={index}
                onClick={() => {
                  if (setNpsAnswers) {
                    setNpsAnswers((prev) => ({
                      ...prev,
                      [item.id]: value,
                    }));
                  }
                }}
                sx={{
                  display: "flex",
                  flex: 1,
                  minWidth: "0",
                  padding: "14.5px 8px",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "4px",
                  borderRight:
                    index < npsScale.length - 1
                      ? `1px solid ${customStyle?.borderColor ?? "#D9DBE9"}`
                      : "none",
                  backgroundColor: isSelected
                    ? customStyle?.accentColor
                      ? customStyle?.accentColor
                      : "#000"
                    : "#FFFFFF",
                  color: isSelected
                    ? "#FFFFFF"
                    : customStyle?.textColor ?? "#353A3F",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "normal",
                  fontFamily: `var(--font-${customStyle?.bodyFont})` ?? "Lato",
                  transition: "background-color 0.2s ease, color 0.2s ease",
                  "&:hover": {
                    backgroundColor: isSelected
                      ? customStyle?.accentColor ?? "var(--color-black)"
                      : "#F8F9FA",
                  },
                }}
              >
                {value}
              </ButtonBase>
            );
          })}
        </Box>

        {/* Hidden input for form submission */}
        <input
          type="hidden"
          name={`answer[${item.id}][]`}
          value={selectedValue || ""}
          {...(Boolean(item.is_required) && {
            required: "required",
          })}
        />

        {item.choices && item.choices.length >= 2 && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: "10px",
              mt: "8px",
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: customStyle?.secondaryTextColor ?? "#6E757C",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "20px",
                  fontFamily: `var(--font-${customStyle?.bodyFont})`,
                }}
              >
                {item.choices?.[0]?.options ?? ""}
              </Typography>
            </Box>

            <Box>
              <Typography
                sx={{
                  color: customStyle?.secondaryTextColor ?? "#6E757C",
                  fontSize: "13px",
                  fontStyle: "normal",
                  fontWeight: "500",
                  lineHeight: "20px",
                  fontFamily: `var(--font-${customStyle?.bodyFont})`,
                }}
              >
                {item.choices?.[1]?.options ?? ""}
              </Typography>
            </Box>
          </Box>
        )}
      </>
    );
  }

  // Use react-hook-form when control is provided
  return (
    <Fc
      name={`answer[_${item.id}]`}
      control={control}
      render={({ field }) => {
        const selectedValue = field?.value ?? null;

        return (
          <>
            <Box
              mt={1}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: "0px",
                justifyContent: "space-between",
                width: "100%",
                borderRadius: "10px",
                border: `1px solid ${customStyle?.borderColor ?? "#D9DBE9"}`,
                overflow: "hidden",
              }}
            >
              {npsScale.map((value, index) => {
                const isSelected = selectedValue === value;
                return (
                  <ButtonBase
                    key={index}
                    onClick={() => {
                      setValue(`answer[_${item.id}]`, value);
                    }}
                    sx={{
                      display: "flex",
                      flex: 1,
                      minWidth: "0",
                      padding: "14.5px 8px",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "4px",
                      borderRight:
                        index < npsScale.length - 1
                          ? `1px solid ${customStyle?.borderColor ?? "#D9DBE9"}`
                          : "none",
                      backgroundColor: isSelected
                        ? customStyle?.accentColor ?? "var(--color-black)"
                        : "#FFFFFF",
                      color: isSelected
                        ? "#FFFFFF"
                        : customStyle?.textColor ?? "#353A3F",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "normal",
                      fontFamily:
                        `var(--font-${customStyle?.bodyFont})` ?? "Lato",
                      transition: "background-color 0.2s ease, color 0.2s ease",
                      "&:hover": {
                        backgroundColor: isSelected
                          ? customStyle?.accentColor ?? "var(--color-black)"
                          : "#F8F9FA",
                      },
                    }}
                  >
                    {value}
                  </ButtonBase>
                );
              })}
            </Box>

            {item.choices && item.choices.length >= 2 && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  gap: "10px",
                  mt: "8px",
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      color: customStyle?.secondaryTextColor ?? "#6E757C",
                      fontSize: "13px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "20px",
                      fontFamily: `var(--font-${customStyle?.bodyFont})`,
                    }}
                  >
                    {item.choices?.[0]?.options ?? ""}
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    sx={{
                      color: customStyle?.secondaryTextColor ?? "#6E757C",
                      fontSize: "13px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      lineHeight: "20px",
                      fontFamily: `var(--font-${customStyle?.bodyFont})`,
                    }}
                  >
                    {item.choices?.[1]?.options ?? ""}
                  </Typography>
                </Box>
              </Box>
            )}
          </>
        );
      }}
    />
  );
};

export default QuestionNPS;
